import { AchievePage, WfsPage, FdrPage, FfnPage } from 'utils/environmentConfig'

/**
 * Feature toggles. Some should remain permanent, but consider removing flags after page/feature is
 * launched when appropriate.
 */
const ACX_WEB_CLEAR_CACHE = 'acx-apollo-memory-cache-clear'
const ACX_WEB_ENABLE_ACCELERATION_LOAN = 'acx-web-enable-acceleration-loan'
const ACX_WEB_ENABLE_ALCHEMER_SURVEY = 'acx-web-enable-alchemer-survey'
const ACX_WEB_ENABLE_ARTICLE_HOOK = 'acx-web-enable-article-hook'
const ACX_WEB_ENABLE_AUTHORS = 'acx-web-enable-authors'
const ACX_WEB_ENABLE_CACHE_PURGE_SLACK_ALERTS = 'acx-website-cache-purge-slack-alerts'
const ACX_WEB_ENABLE_DEBT_PAYOFF_CALCULATOR = 'acx-web-enable-debt-assessment-tool'
const ACX_WEB_ENABLE_DEBT_PAYOFF_CALCULATOR_MXP = 'acx-web-enable-debt-assessment-tool-mxp'
const ACX_WEB_ENABLE_DIRECT_MAIL_LINK = 'acx-web-enable-direct-mail-link'
const ACX_WEB_ENABLE_FAQ_HOME_EQUITY_LOAN = 'acx-web-enable-faq-home-equity-loan'
const ACX_WEB_ENABLE_FAQ_PERSONAL_LOAN = 'acx-web-enable-faq-personal-loan'
const ACX_WEB_ENABLE_FAQ_RESOLVE_DEBT = 'acx-web-enable-faq-resolve-debt'
const ACX_WEB_ENABLE_GLOSSARY = 'acx-web-enable-glossary'
const ACX_WEB_ENABLE_MXP_DEBT_CHECKUP = 'acx-web-enable-mxp-debt-checkup'
const ACX_WEB_ENABLE_NAV_TITLES = 'acx-web-enable-nav-titles'
const ACX_WEB_ENABLE_SIGN_IN_MXP = 'acx-web-enable-sign-in-mxp'
const ACX_WEB_ENABLE_SITE_WIDE_BANNER = 'acx-web-enable-site-wide-banner'
const ACX_HELOC_TOOL = 'acx-web-enable-heloc-tool'

/**
 * Feature experiment toggles object map. Enabled for all including crawlers.
 */
const FEATURES = {
  [AchievePage]: {
    ACX_WEB_ENABLE_ALCHEMER_SURVEY,
    ACX_WEB_ENABLE_NAV_TITLES,
    ACX_WEB_ENABLE_FAQ_RESOLVE_DEBT,
    ACX_WEB_ENABLE_FAQ_PERSONAL_LOAN,
    ACX_WEB_ENABLE_FAQ_HOME_EQUITY_LOAN,
    ACX_WEB_ENABLE_SITE_WIDE_BANNER,
    ACX_WEB_ENABLE_ARTICLE_HOOK,
    ACX_WEB_ENABLE_ACCELERATION_LOAN,
    ACX_WEB_ENABLE_DEBT_PAYOFF_CALCULATOR,
    ACX_WEB_ENABLE_DEBT_PAYOFF_CALCULATOR_MXP,
    ACX_WEB_ENABLE_SIGN_IN_MXP,
    ACX_WEB_ENABLE_AUTHORS,
    ACX_WEB_ENABLE_MXP_DEBT_CHECKUP,
    ACX_WEB_ENABLE_DIRECT_MAIL_LINK,
    ACX_WEB_ENABLE_CACHE_PURGE_SLACK_ALERTS,
    ACX_WEB_CLEAR_CACHE,
    ACX_WEB_ENABLE_GLOSSARY,
    ACX_HELOC_TOOL,
  },
  [WfsPage]: {},
  [FdrPage]: { ACX_WEB_ENABLE_GLOSSARY },
  [FfnPage]: {},
}

/**
 * Experiment toggles. These should removed once experiments are concluded.
 */
const ACX_DEBT_CONSOLIDATION_PZN = 'acx-debt-consolidation-pzn'
const ACX_DTI_CONTENT_EXPERIMENT = 'acx-dti-content-experiment'
const ACX_HOMEHERO_ABC_EXPERIMENT = 'acx-homehero-experiment'
const ACX_RESOLVE_DEBT_PZN = 'acx-resolve-debt-pzn'
const ACX_STICKY_FOOTER_HEADER = 'acx-sticky-footer-header'
const ACX_WEB_BANNER_POSITION = 'acx-web-banner-position'
const ACX_WEB_DR_MP_VS_LX = 'acx-dr-mp-vs-lx'
const ACX_WEB_EXPERIMENT_AHL_HEADLINE_RATE = 'acx-ahl-headline-rate'
const ACX_WEB_EXPERIMENT_DTI_CALCULATOR_V2 = 'acx-dti-calculator-v2'
const ACX_WEB_EXPERIMENT_GOOD_MOLO_SKELETON = 'acx-good-molo-skeleton-experiment'
const ACX_WEB_EXPERIMENT_DPC_BARCHARTS = 'acx-dpc-barcharts'
const ACX_WEB_EXPERIMENT_HL_HUB_TEMPLATE = 'acx-hl-hub-template-experiment'
const ACX_WEB_EXPERIMENT_HOME_HERO_V2 = 'acx-experiment-home-hero-v2'
const ACX_WEB_EXPERIMENT_HOME_PAGE_PZN = 'acx-home-page-pzn'
const ACX_WEB_EXPERIMENT_HOMEPAGE_TRUST_PILOT_TRUSTMARKER =
  'acx-homepage-trust-pilot-trustmarker-experiment'
const ACX_WEB_EXPERIMENT_PFQ_BANNER = 'acx-pfq-banner'
const HOME_EQUITY_LOAN_MP_EXPERIMENT = 'home-equity-loan-mp-experiment'

/**
 * Feature experiment toggles object map. These flags will not be included if crawlers are detected.
 */
const EXPERIMENTS = {
  [AchievePage]: {
    ACX_DEBT_CONSOLIDATION_PZN,
    ACX_DTI_CONTENT_EXPERIMENT,
    ACX_HOMEHERO_ABC_EXPERIMENT,
    ACX_RESOLVE_DEBT_PZN,
    ACX_STICKY_FOOTER_HEADER,
    ACX_WEB_BANNER_POSITION,
    ACX_WEB_DR_MP_VS_LX,
    ACX_WEB_EXPERIMENT_AHL_HEADLINE_RATE,
    ACX_WEB_EXPERIMENT_DTI_CALCULATOR_V2,
    ACX_WEB_EXPERIMENT_GOOD_MOLO_SKELETON,
    ACX_WEB_EXPERIMENT_DPC_BARCHARTS,
    ACX_WEB_EXPERIMENT_HL_HUB_TEMPLATE,
    ACX_WEB_EXPERIMENT_HOME_HERO_V2,
    ACX_WEB_EXPERIMENT_HOME_PAGE_PZN,
    ACX_WEB_EXPERIMENT_HOMEPAGE_TRUST_PILOT_TRUSTMARKER,
    ACX_WEB_EXPERIMENT_PFQ_BANNER,
    HOME_EQUITY_LOAN_MP_EXPERIMENT,
    ACX_HELOC_TOOL,
  },
  [WfsPage]: {},
  [FdrPage]: {},
  [FfnPage]: {},
}

/**
 * All possible feature toggles whether basic feature enablement or experiments. This object is
 * referenced in components to determine if a feature should be enabled or not.
 */
export const FEATURE_TOGGLES = {
  EXPERIMENTS,
  FEATURES,
  [AchievePage]: {
    ...FEATURES[AchievePage],
    ...EXPERIMENTS[AchievePage],
  },
  [WfsPage]: {
    ...FEATURES[WfsPage],
    ...EXPERIMENTS[WfsPage],
  },
  [FdrPage]: {
    ...FEATURES[FdrPage],
    ...EXPERIMENTS[FdrPage],
  },
  [FfnPage]: {
    ...FEATURES[FfnPage],
    ...EXPERIMENTS[FfnPage],
  },
}

export const SESSION_BASED_FEATURE_TOGGLES = []

export const EVENT_TYPES = {
  START: 'start',
  CONVERSION: 'conversion',
  TRACK: 'track',
}

// values should be all lower case
export const VARIATIONS = {
  CONTROL: 'control',
  VARIATION_A: 'variation_a',
  VARIATION_B: 'variation_b',
  VARIATION_C: 'variation_c',
  UNASSIGNED: 'unassigned',
  OFF: 'off',
}

export const VARIATIONS_UPPER = {
  CONTROL: 'Control',
  VARIATION_A: 'Variation_A',
  VARIATION_B: 'Variation_B',
  VARIATION_C: 'Variation_C',
  UNASSIGNED: 'Unassigned',
  OFF: 'Off',
}

export const PFQ_BANNER_ROUTES = ['/learn', '/glossary', '/tools', '/good-app', '/molo-app']

export const STANDALONE_ROUTE_EXPERIMENT_BLACKLIST = [ACX_WEB_BANNER_POSITION]

export default FEATURE_TOGGLES
